<template>
  <div class="hello">
    <div class="top">
      <span class="yqh">邀请函配置</span>
      <span class="ct" @click="configuration">餐厅配置</span>
    </div>
    <div class="body">
      <div class="title">邀请信息：</div>
      <van-form ref="form">
        <van-field
          v-model="name"
          label="被邀请人"
          placeholder="请输入"
          @blur="blur"
        />        
        <div class="xian"></div>
        <!-- <div v-show="!name&&showT" class="tishi">请填写被邀请人</div> -->
        <div class="time">
        <van-field
          v-model="time"
          label="邀请时间"
          placeholder="请选择"
          readonly
          @click="open"
          @blur="blur"
        />
          <div class="icon" @click="open"><img src="../assets/素材/日历.png" alt=""></div>
       </div>
        <div class="xian"></div>
        <div v-show="!time&&showT" class="tishi">请选择邀请时间</div>
        <div class="title2">邀请致辞</div>
        <div class="box">
          <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="500"
          placeholder="请输入，并请自行排版换行"
          show-word-limit
          @blur="blur"
        />
        </div>
        <div v-show="!message&&showT" class="tishi">请填写邀请致辞</div>
        <div class="title3">餐厅信息：</div>
        <van-field
          v-model="RestaurantName"
          readonly
          label="餐厅名称"
          placeholder=""
          @blur="blur"
        />
        <div class="xian"></div>
        <div v-show="!RestaurantName&&showT" class="tishi">请填写餐厅名称</div>
        <van-field
          v-model="RestaurantAddress"
          readonly
          label="餐厅地址"
          placeholder=""
          @blur="blur"
        />
        <div class="xian"></div>
        <div v-show="!RestaurantAddress&&showT" class="tishi">请填写餐厅地址</div>
        <van-field
          v-model="linkman"
          readonly
          label="联系人"
          placeholder=""
          class="lxr"
          @blur="blur"
        />
        <div class="xian"></div>
        <div v-show="!linkman&&showT" class="tishi">请填写联系人</div>
        <van-field
          v-model="phone"
          readonly
          label="联系电话"
          placeholder=""
          @blur="blur"
        />
        <div class="xian"></div>
        <div v-show="!phone&&showT" class="tishi">请填写联系电话</div>
      </van-form>
    </div>
    <div class="create" @click="create">生成邀请链接</div>
    <van-popup v-model="currentDate" position="bottom">
      <van-datetime-picker
      type="datetime"
      title="请选择年月日时分"
      v-model="selectedDate"
      @confirm="onConfirm"
      @cancel="currentDate = false"
    />
    </van-popup>
    <!-- <van-datetime-picker
      v-show="currentDate"
      type="datetime"
      title="选择完整时间"
      @confirm="onConfirm"
      @cancel="currentDate = false"
    /> -->
  </div>
</template>

<script>
export default {
  name: "InvitationConfiguration",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      time: "",
      message: '',
      RestaurantName: "",
      RestaurantAddress: "",
      RestaurantId: '',  
      linkman: "",
      phone: "",
      userId: "",
      currentDate: false,
      showT: false,
      list: {},
      imgs: [],
      selectedDate: new Date()
    };
  },
  mounted() {
    const data = JSON.parse(localStorage.getItem('data'))
    if(data) {
      this.RestaurantName = data.title
      this.RestaurantAddress = data.province + data.city + data.district + data.address
      this.linkman = data.contact_person
      this.phone = data.contact_phone
      this.RestaurantId = data.id
      this.message = `诚邀您莅临${this.RestaurantName}用餐\n真诚期待您的光临,祝您用餐愉快~`
      const img = data.photos
      const options = {}
      img.forEach(item => {
        const url = this.$baseUrl.files.getUrl(data, item, options);
        this.imgs.push(url)
      })
    }else {
      this.getRestaurants()
    }
  },
  // activated() {  
  //   location.reload();
  // },  
  methods: {
    open() {
      this.currentDate = true;
    },
    blur() {
      this.showT = true
    },
    configuration() {
      // this.$router.push("/restaurant");
      this.$router.push({ path: "/restaurant"});
    },
    async getRestaurants() {  
      const list = await this.$baseUrl.collection("restaurant").getFirstListItem("", {sort: "-created",}); 
      console.log(list,999);
      this.list = list
      this.RestaurantName = list.title
      this.RestaurantAddress = list.province + list.city + list.district + list.address
      this.linkman = list.contact_person
      this.phone = list.contact_phone
      this.RestaurantId = list.id
      this.message = `诚邀您莅临${this.RestaurantName}用餐\n真诚期待您的光临,祝您用餐愉快~`
      const img = list.photos
      const options = {}
      img.forEach(item => {
        const url = this.$baseUrl.files.getUrl(list, item, options);
        this.imgs.push(url)
      })
    },
    async newInvitationLetter() {  
      const result = await this.$baseUrl.collection("invitation_letter").create({
      invitee: this.name, // 被邀请人
      invited_at: this.time, // 时间
      letter_content: this.message, // 邀请函内容
      restaurant: this.RestaurantId, // 餐厅id
      });
      console.log(result);
      this.userId = result.id
      console.log(this.userId);
      this.$router.push({ path: '/invite', query: { id: this.userId } })
    },
    onConfirm(value) {
      // 使用 Date 对象解析字符串  
      let date = new Date(value);
      // this.selectedDate = value.getSelectedDate();  
      // console.log('选中的日期时间：', this.selectedDate); 
      // 获取星期几的数值，并转换为字符串  
      // let dayOfWeek = '星期'+['日', '一', '二', '三', '四', '五', '六'][date.getDay()]; 
      // 格式化日期和时间  
      let formattedDate = date.getFullYear() + '-' +  
        ('0' + (date.getMonth() + 1)).slice(-2) + '-' +  
        ('0' + date.getDate()).slice(-2) + ' ' +  
        ('0' + date.getHours()).slice(-2) + ':' +  
        ('0' + date.getMinutes()).slice(-2) + ':' +  
        ('0' + date.getSeconds()).slice(-2);  
      console.log(formattedDate);
      console.log(value,111)
      this.time = formattedDate;
      this.selectedDate = date
      console.log(this.time);
      this.currentDate = false;
    },
    create() {
      if(!this.time || !this.message || !this.RestaurantName || !this.RestaurantAddress || !this.linkman || !this.phone){
        return
      }
      this.newInvitationLetter()
      // this.$refs.form.validate().then(() => {  
      //   // 校验成功，提交表单数据  
      //   console.log('表单数据:');
      //   this.newInvitationLetter()
      //   // this.$router.push("/invite");
      // }).catch((err) => {  
      //   // 校验失败，处理错误信息  
      //   console.log('校验失败:', err);  
      // });
    }
  }
};
</script>
<style>
.top {
  width: 100%;
  height: 100px;
  background: linear-gradient(
    225deg,
    rgb(205, 165, 130) 0%,
    rgb(170, 128, 92) 100%
  );
  display: flex;
  align-items: center;
}
.yqh {
  flex: 1;
  text-align: center;
  margin-left: 135px;
  color: rgb(255, 255, 255);
  font-size: 32px;
}
.ct {
  width: 107px;
  margin-right: 28px;
  color: rgb(255, 255, 255);
  font-size: 26px;
}
.body {
  padding: 0 45px;
}
.body .title {
  margin: 38px 0 0 14px;
  color: rgb(170, 128, 92);
  font-size: 32px;
}
.body .title2 {
  color: rgb(105, 105, 105);
  margin: 43px 0 22px 14px;
  font-size: 26px;
}
.body .title3 {
  margin: 66px 0 0 14px;
  color: rgb(170, 128, 92);
  font-size: 32px;
}
.van-cell {
  overflow: visible;
  padding: 0;
  height: 50px;
  margin-top: 35px;
  align-items: center;
}
.van-cell::after {
  display: none;
}
.van-field__label {
  margin-right: 46px !important;
  margin-left: 14px !important;
  width: auto !important;
}
.van-field__label span {
  font-size: 26px;
  color: rgb(105, 105, 105);
}
.van-cell__value {
  height: 40px;
}
.van-field__error-message {
  font-size: 26px !important;
}
.van-field__body {
  height: 95%;
}
.van-field__control {
  font-size: 26px;
  color: rgb(105, 105, 105);
}
.xian {
  height: 1px;
  background: rgb(219, 219, 219);
  margin-top: 15px;
}
.van-form {
  position: relative;
}
.time {
  position: relative;
}
.time .icon {
  position: absolute;
  top: 5px;
  right: 15px;
  width: 35px;
  height: 35px;
}
.time .icon img {
  width: 100%;
  height: 100%;
}
.box {
  border-radius: 10px;
  height: 250px;
  background: rgb(243, 243, 243);
}
.box .van-cell {
  background-color: transparent;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
}
.box .van-cell .van-field__value {
  width: 100%;
  height: 100%;
}
.box .van-cell .van-field__value .van-field__control {
  width: 100%;
  height: 100% !important;
  padding: 14px !important;
  overflow-y: auto;
  line-height: 40px; 
}
.van-picker {
    position: fixed !important;
    width: 100%;
    left: 0;
    bottom: 0;
}
.van-field__word-limit {
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: rgb(219, 219, 219) !important;
  font-size: 24px !important;
}
.create {
  width: 654px;
  height: 80px;
  margin: 93px auto 69px;
  border-radius: 50px;
  box-shadow: 5px 10px 15px 0px rgba(170, 128, 92, 0.4);
  background: linear-gradient(-37.26deg, rgb(205, 165, 130) 8.033%,rgb(170, 128, 92) 96.701%);
  color: rgb(255, 255, 255);
  font-size: 32px;
  text-align: center;
  line-height: 80px;
}
.tishi {
  color: #ee0a24;
  font-size: 24px;
  margin-left: 14px;
}
.lxr .van-field__label {
  margin-right: 72px !important;
  margin-left: 14px !important;
  width: auto !important;
}
</style>
